'use strict';

var scriptsValidator = require('./scriptsValidator');
var workerUtils = require('./workerUtils');
var biUtils = require('./../biUtils');
var events = require('../events');
var errors = require('../errors');
var constants = require('../constants');
var MessageType = require('./MessageType');
var scriptsHandler = require('./scriptHandler');

function importScripts(url, scriptName, onSuccess, onFailure) {
  var beforeLoad = Date.now();
  try {
    scriptsHandler.importScripts(url);
    workerUtils.reportBI(events.SCRIPT_LOAD, {
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad
    });
    if (onSuccess) {
      onSuccess();
    }
  } catch (err) {
    /*eslint-disable no-console*/
    console.error('Failed to import script: ' + scriptName + ', url: ' + url);
    workerUtils.reportBI(errors.SCRIPT_LOAD, {
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad,
      error: err.message
    });
    if (onFailure) {
      onFailure(err);
    }
  }
}

function loadSdk(parameters, sdkUrl) {
  const onSuccess = () => self.wix.__INTERNAL__.initEnv(parameters);
  const onFailure = err => {
    throw new Error(err);
  };
  importScripts(sdkUrl, 'wixCode-sdk', onSuccess, onFailure);
}

function loadModules(modules, appsStore) {
  modules.forEach(module => {
    var app = workerUtils.importScriptsAsNpmModule(self, module.url, module.id, module.displayName, scriptsHandler);
    appsStore.set(module.id, {
      module: app,
      applicationId: module.applicationId,
      appDefId: module.id,
      controllers: {}
    });
    if (!module.applicationId && module.appInnerId) {
      appsStore.mapInnerId(module.appInnerId, module.id);
    }
  });
}

function handleBootstrap(messageData, appsStore) {
  var bootstrapArgs = messageData.bootstrapArguments;
  const {wixCodeScripts, metaSiteId, viewerSessionId, ownerId} = bootstrapArgs;
  if (!bootstrapArgs.sdkParameters) {
    throw new Error('Could not load user code: `sdkParameters` has an invalid value: ' + bootstrapArgs.sdkParameters);
  }

  self.biSessionModel = biUtils.createBiSession(metaSiteId, viewerSessionId, ownerId);

  var scripts = JSON.parse(decodeURIComponent(bootstrapArgs.applications));
  scriptsValidator.validate(scripts, ['id', 'url']);

  if (scripts.some(app => app.id === constants.DATA_BINDING)) {
    wixCodeScripts.forEach(({url, id}) => {
      importScripts(url, id);
    });
  }
  loadSdk(bootstrapArgs.sdkParameters, bootstrapArgs.sdkSource);
  loadModules(scripts, appsStore);
  workerUtils.sendMessage({
    intent: 'WIX_CODE_SSR',
    type: MessageType.BOOTSTRAP_DONE
  });
}

module.exports = {
  handleBootstrap
};



// WEBPACK FOOTER //
// ./src/main/worker/bootstrapHandler.js